module.exports = __webpack_public_path__ + "static/media/add.6a0e9972.svg";